import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { getSatisfactionColor, getImportanceColor } from "../utils/helpers";
import { TipsAndUpdates } from "@mui/icons-material";

const SubCategory = ({ subCategory }) => {
  return (
    <Box sx={{ mb: 6, px: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 2,
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            color: "#4B5563",
            flex: 1,
            fontSize: "22px",
            fontWeight: "bold",
            textWrap: "wrap",
            wordBreak: "break-word",
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          {subCategory.name}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "auto" },
            px: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              border: `1px solid ${getSatisfactionColor(subCategory.satisfaction_level)}`,
              bgcolor: `${getSatisfactionColor(subCategory.satisfaction_level)}20`,
              px: { xs: 0.5, sm: 1 },
              py: { xs: 0, sm: 0.5 },
              borderRadius: "5px",
            }}
          >
            {["Excellent", "Good", "Satisfactory"].includes(
              subCategory.satisfaction_level
            ) ? (
              <ThumbsUp
                size={20}
                color={getSatisfactionColor(subCategory.satisfaction_level)}
              />
            ) : (
              <ThumbsDown
                size={20}
                color={getSatisfactionColor(subCategory.satisfaction_level)}
              />
            )}
            <Typography variant="caption" color={getSatisfactionColor(subCategory.satisfaction_level)}>
              {subCategory.satisfaction_level}
            </Typography>
          </Box>
          <Typography
            variant="caption"
            sx={{ color: `${getImportanceColor(subCategory.importance)}`, fontWeight: "bold" }}
          >
            {subCategory.importance}
          </Typography>
        </Box>
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        {subCategory.description}
      </Typography>

      <Stack spacing={1} sx={{ mb: 4 }}>
        {subCategory.observations.map((item, index) => (
          <Typography
            key={index}
            variant="body1"
            color="text.secondary"
            sx={{ pl: { xs: 0, sm: 3 }, position: "relative" }}
          >
            • {item}
          </Typography>
        ))}
      </Stack>

      <Box>
        <Typography
          variant="h6"
          sx={{ mb: 2, fontSize: "19px", fontWeight: "550" }}
        >
          <TipsAndUpdates sx={{ mr: "5px", fontSize:"15px", color: "rgb(249, 181, 86)" }} />Recommendations:
        </Typography>
        <Stack spacing={1}>
          {subCategory.reccos.map((recommendation, index) => (
            <Typography
              key={index}
              variant="body1"
              color="text.secondary"
              sx={{ pl: { xs: 0, sm: 3 }, position: "relative" }}
            >
              • {recommendation}
            </Typography>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default SubCategory;
